import { isAndroid } from "@braintree/browser-detection"
import { useCallback, useEffect, useState } from "react"

// Device-specific meeting/browser behavior. Responsive UI uses the hook below.
// Android phones include "Mobile" in the UA; tablets typically do not.
export const isMobilePhone =
  /iPhone|iPod/i.test(navigator.userAgent) ||
  (isAndroid() && /Mobile/i.test(navigator.userAgent))

const MOBILE_BREAKPOINT = 719

export const useIsMobileOrTablet = (): boolean => {
  const [isMobile, setIsMobile] = useState(
    () => window.innerWidth <= MOBILE_BREAKPOINT,
  )

  const handleResize = useCallback(() => {
    setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT)
  }, [])

  useEffect(() => {
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [handleResize])

  return isMobile
}
